import React, { useEffect, useRef, useState } from 'react'
import './my-xp-earnings-list.styles.scss';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useLocation, useNavigate } from 'react-router-dom';
import PlayerNameIcon from '../player-name-icon.component';
import PlayerEarningsList from '../player-earnings-list.component';

const MyXpEarningsList = ({
  gameData,
  playerData,
  gameElements
}) => {

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!gameData?.gameName) return;
    const pageTitleEl = document.getElementById('page-title');
    if (pageTitleEl) {
      pageTitleEl.innerText = 'XP Earnings';
    }
    changeDocumentTitle(`XP Earnings | ${gameData.gameName}`)
  }, [gameData?.gameName])

  return (
    <div className='xp-earnings-list'>
      <div className='g-card list-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div>
          <div className='card-title split'>
            XP Earnings
            {
              (location.pathname.includes('/manage/')) &&
              <PlayerNameIcon player={playerData} />
            }
          </div>
          <div className='g-space-1'></div>
          <hr className='no-margin' />
          <div className='g-space-0-5'></div>
          {
            (playerData) &&
            <div className='summary meta'>
              <div className='info'>
                Total XP Earned:
                <ImageContainer src='/images/xp.png' className='summary-icon' />
                <b>{playerData.points.toLocaleString()}</b>
              </div>
            </div>
          }
        </div>
        {
          (gameData && playerData && gameElements) &&
          <PlayerEarningsList
            gameData={gameData}
            playerData={playerData}
            gameElements={gameElements}
            type='xp' />
        }
      </div>
      <div className="g-space-2"></div>
    </div>
  )
}

export default MyXpEarningsList